import { useFormContext } from "react-hook-form";

import Grid from "@mui/material/Grid";

import SelectFormField from "components/select-form-field";
import { HEARING_AID_TYPES, TECHNOLOGIES } from "constants/products";

import { AddMasterProductFormValues } from "../add-master-product-form.component";

export default function HearingAidSpecificationForm() {
  const { control } = useFormContext<AddMasterProductFormValues>();
  return (
    <Grid
      container
      width="100%"
      sx={{ pb: 4 }}
      columnSpacing={2}
      rowSpacing={4}
    >
      <Grid item xs={6}>
        <SelectFormField
          name="specification.type"
          label="Type"
          control={control}
          options={HEARING_AID_TYPES.getOptions()}
          required
          dropDownZIndex={1502}
        />
      </Grid>
      <Grid item xs={6}>
        <SelectFormField
          name="specification.technology"
          label="Technology"
          control={control}
          options={TECHNOLOGIES.getOptions()}
          required
          dropDownZIndex={1502}
        />
      </Grid>
    </Grid>
  );
}
